module.exports = __webpack_public_path__ + "officialStatic/img/news11.c973c05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/news11.jpg
// module id = NOtL
// module chunks = 0